import React, { useEffect } from 'react';
import MembGameLoginApi from 'Apis/MembGameLoginApi';
import { useState ,useCallback } from 'react';
import { Helmet } from 'react-helmet-async';
import { useNavigate ,useLocation, Link} from "react-router-dom";
import UseLangLstQuery from 'Apis/LangTxtInqApi';
import AppSsoLoginUi from './AppSsoLoginUi';
import MembJoinLink from './AppMembJoinLink';
import IsLoginApi from 'Apis/IsLoginApi';
import { useSelector } from 'react-redux';

import { useGtm, fetchAdPayload, getKstTimestamp } from 'hooks/useGtm';
import MgpStore from "Stores/Store";
import { useDispatch} from 'react-redux';
import useRecaptcha from 'Utils/useRecaptcha';
import AppMembJoinLink from './AppMembJoinLink';
import MbpAthnTknCrtRqstApi from 'Apis/MbpAthnTknCrtRqstApi';
import { isMobile } from 'react-device-detect';
import refererApi from 'Apis/refererApi';


declare global {
    interface Window {
        fbq?: (...args: any[]) => void;
    }
}
const AppLogin = () => {
    const { push: gtmPush } = useGtm();
    const location= useLocation();  
    const serchParamsFunc = () => {
        return new URLSearchParams(location.search);
    }
    let query =serchParamsFunc();
    let getGameSvcCd = query.get("gameSvcCd");
    let osKindCd = query.get("osKindCd");
    let redirectUri = query.get("redirectUri");

    const dispatch = useDispatch();
    const [loginId,setLoginId] = useState("");
    const [passwd,setPasswd] = useState("");
    const [loginAlertTxt,setloginAlertTxt] = useState("");
    
    // 자동로그인 체크박스 상태
    const [mltSetYn, setMltSetYn] = useState("N");
    const {isLoading,error,data: langData}:any = UseLangLstQuery();
    const getLangText = (text:any, fallback = "") => text ?? fallback;
    
    const LoginIdHandler = (event:any) => {
        setLoginId(event.currentTarget.value);
        setloginAlertTxt("");
    }
    const PasswdHandler = (event:any) => {
        setPasswd(event.currentTarget.value);
        setloginAlertTxt("");
    }
    const membJoinLinkTxt = [
        getLangText(langData?.LOGIN_FIND_LOGIN_ID_BTN_00),
        getLangText(langData?.LOGIN_FIND_PASSWD_MAIN_BTN_00),
        getLangText(langData?.LOGIN_MEMB_JOIN_MAIN_BTN_00)
    ];
    const { getToken } = useRecaptcha();
    let navigate = useNavigate();
    useEffect(() => {
        refererApi();
    }, []);
    
    // 전역 로그인 상태 체크
    const loginInfoState = useSelector((state: any) => state.LoginInfoState?.LoginInfo?.apiBody);

    if (isLoading || !langData) {
        return null;
    }

    // 로그인 상태가 true면 바로 리다이렉트
    if (loginInfoState && loginInfoState.login === true) {
        navigate("/Connect/AppStrt", { state: { gameSvcCd: getGameSvcCd, pageCd: "login" }, replace: true });
        return null;
    }
    const AutoLoginHandler = (event:any) => {
        setMltSetYn(event.target.checked ? "Y" : "N");
    }
    const MembLoginFunc = async (e:any) => {
        e.preventDefault();
        if(!loginId) {
            setloginAlertTxt(getLangText(langData?.MEMB_JOIN_ID_INPUT_DESC_00));
            //아이디를 입력해주세요.
        }else if(!passwd){
            setloginAlertTxt(getLangText(langData?.MEMB_JOIN_PASSWD_INPUT_DESC_00))
            // 비밀번호를 입력해주세요.
        }else {
            try {
                const token = await getToken('login');
                const Resp = await MembGameLoginApi("BBO", loginId, passwd, token, redirectUri, mltSetYn);
                switch(Resp.data.apiHdr.code){
                    case "GAME0000":
                         if (window.fbq) {
                        window.fbq('trackCustom', 'BBO_FB_Login_Complete');
                    }
                    const tsKst = getKstTimestamp();
                    const adPayload = await fetchAdPayload(getGameSvcCd || 'BBO');
                    try {

                        gtmPush('BBO_GA_Login_Complete', {
                            ts: tsKst,
                            ...adPayload,
                        });
                    } catch (gtmErr) {
                        if (typeof window !== 'undefined') {
                            window.dataLayer = window.dataLayer || [];
                            window.dataLayer.push({
                                event: 'BBO_GA_Login_Complete',
                                ts: tsKst,
                                ...adPayload,
                            });
                        }
                    }
                       navigate(`/Connect/AppStrt`,{ state: { pageCd: "login" }, replace:true });
                        break;
                    case "ATHN2000":
                        setloginAlertTxt(getLangText(langData?.LOGIN_MAIN_RSLT_DESC_00));
                    break;
                    case"ATHN2002":
                        navigate("/Connect/BlckMemb",{state:{loginId:loginId},replace:true});
                    break;
                    case"ATHN2003":
                        navigate("/Connect/DrmcMemb",{state:{loginId:loginId},replace:true});
                    break;  
                    case"ATHN2005":
                        navigate("/Connect/membLvdCncl",{state:{loginId:loginId},replace:true});
                    break; 
                    case "ATHN2007": {
                        // 현재 리퍼러 파라미터를 OTP 페이지로 넘김
                        navigate(`/Connect/OtpAthn`,{state:{idntMthdCd:Resp.data.apiBody.param},replace:true});
                    }
                    break;  
                    case"ATHN2008":
                        openMbpAthnWindow("MTHD_CHNG_APP", loginId);
                    break;      
                    case"ATHN2309":
                        setloginAlertTxt(getLangText(langData?.LOGIN_MAIN_RSLT_DESC_00));
                    break;
                    case"ATHN2313":
                        setloginAlertTxt("로그인 시도 횟수가 많습니다. 잠시 후 다시 시도해주세요.");
                    break;
                    default:
                        setloginAlertTxt(`${Resp.data.apiHdr.msg} `);
                    break;
                    
                }
            } catch (e) {
                // eslint-disable-next-line no-console
                console.error('reCAPTCHA token failed', e);
            }
        }
    }
    const openMbpAthnWindow = async (athnPrpsCd:string = "MTHD_CHNG_APP", loginId:string|null = null) => {
        try {
            const tokenResp = await MbpAthnTknCrtRqstApi(athnPrpsCd, loginId);
            if(tokenResp.apiHdr.code !== "ATHN0000") {
                alert(`${tokenResp.apiHdr.msg}`);
                return;
            }

            const reqKMCISForm = document.createElement("form");
            reqKMCISForm.method = "post";
            reqKMCISForm.action = "https://www.kmcert.com/kmcis/web/kmcisReq.jsp";
            reqKMCISForm.style.display = "none";

            const trCertInput = document.createElement("input");
            trCertInput.type = "hidden";
            trCertInput.name = "tr_cert";
            trCertInput.value = tokenResp.apiBody.kmcTkn;

            const trUrlInput = document.createElement("input");
            trUrlInput.type = "hidden";
            trUrlInput.name = "tr_url";
            trUrlInput.value = `${process.env.REACT_APP_KMC_REDIRECT_URL}`;

            const trVerInput = document.createElement("input");
            trVerInput.type = "hidden";
            trVerInput.name = "tr_ver";
            trVerInput.value = "V2";

            reqKMCISForm.appendChild(trCertInput);
            reqKMCISForm.appendChild(trUrlInput);
            reqKMCISForm.appendChild(trVerInput);
            document.body.appendChild(reqKMCISForm);

            const isMacDesktop = !isMobile && /Mac/i.test(navigator.platform || navigator.userAgent);

            if(isMobile === true || isMacDesktop) {
                reqKMCISForm.target = "";
            }else {
                const KMCIS_window = window.open('', 'KMCISWindow', 'width=425, height=550, resizable=0, scrollbars=no, status=0, titlebar=0, toolbar=0, left=435, top=250' );
                if(KMCIS_window == null){
                    // alert(" ※ 윈도우 XP SP2 또는 인터넷 익스플로러 7 사용자일 경우에는 \n    화면 상단에 있는 팝업 차단 알림줄을 클릭하여 팝업을 허용해 주시기 바랍니다. \n\n※ MSN,야후,구글 팝업 차단 툴바가 설치된 경우 팝업허용을 해주시기 바랍니다.");
                    document.body.removeChild(reqKMCISForm);
                    return;
                }
                reqKMCISForm.target = "KMCISWindow";
            }

            reqKMCISForm.submit();
            document.body.removeChild(reqKMCISForm);
        }catch(error:any) {
            alert(error?.message || "본인인증 요청 중 오류가 발생했습니다.");
        }
    }
    return(
        <div className='loginInputWrap'>
            <Helmet>
                <title>BE@RBRICK CONNECT - Login</title>
            </Helmet>
            <form action="" onSubmit={MembLoginFunc}>
                <ul className='loginInputUl'>
                    <li>
                        <input placeholder={getLangText(langData?.LOGIN_MAIN_LOGIN_ID_LBL_00)} className='idInput' onChange={LoginIdHandler}></input>
                        {/* 아이디 */}
                    </li>
                    <li>
                        <input placeholder={getLangText(langData?.LOGIN_MAIN_PASSWD_MAIN_LBL_00)} type='password' className='passwdInput' autoComplete="off" onChange={PasswdHandler}></input>
                        {/* 비밀번호 */}
                    </li>
                    
                    <p className='loginAlertTxt'>{loginAlertTxt}</p>
                </ul>
                {/* <div className='agreLi' style={{maxWidth:"390px",margin:"0 auto",marginTop:"45px"}}>
                    <input type="checkbox" id="autoLogin" value={mltSetYn} checked={mltSetYn === "Y"} onChange={AutoLoginHandler} />
                    <label htmlFor="autoLogin">
                            {langData&&langData.GLB_AUTO_LOGIN_CHK_00}
                    </label>
                </div> */}
                <button className='loginBtn gameLoginBtn' type='submit'>{getLangText(langData?.COMM_MAIN_LOGIN_MAIN_BTN_00)}</button>
                {/* 로그인 */}
                <AppMembJoinLink membJoinLinkTxt={membJoinLinkTxt}/>
            </form>
            <div className='appSsoLoginWrap'>
                <p className='appSsoLoginTitl'>소셜 계정으로 로그인</p>
                <AppSsoLoginUi viewType='page' gameSvcCd={getGameSvcCd} mltSetYn={mltSetYn} />
            </div>
            <div className="capthCpyr">
                {/* reCAPTCHA provided at app root; tokens requested via useRecaptcha hook */}
                <p>
                    This site is protected by reCAPTCHA and the Google
                    <br />
                    <a href="https://policies.google.com/privacy" target="_blank">Privacy Policy</a> and
                    <a href="https://policies.google.com/terms"  target="_blank">Terms of Service</a> apply.
                </p>
            </div>
        </div>
    )
}

export default AppLogin;